import { Directive, ElementRef, Input } from '@angular/core';
import { select, Store } from '@ngrx/store';
import { firstValueFrom, Observable } from 'rxjs';
import { Employee } from '../model/employee';
import * as EmployeeSelectors from '../store/selectors/employee.selectors';

@Directive({
  selector: '[canRead]'
})
export class CanReadDirective {

  @Input('canRead') permission: string = '';

  employee$: Observable<Employee | null> = this.store.pipe(select(EmployeeSelectors.selectLoggedInemployee));

  constructor(private elementRef: ElementRef, private store: Store<{ loggedInemployee: Employee }>) { }

  async ngOnInit() {

    const employee = await firstValueFrom(this.employee$);

    if (employee == null) {
      this.hideElement();
      return;
    }

    if (employee.readPermissions?.some(permission => permission === this.permission)) {
      return;
    }

    this.hideElement();
  }

  hideElement() {
    this.elementRef.nativeElement.parentElement.removeChild(this.elementRef.nativeElement);
  }

}
